import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ProjectComponent } from '../pages/project/project.component';
import { Contact } from '../pages/contact/contact';
import { Deelnemers } from '../pages/deelnemers/deelnemers';
import { OverPTRN } from '../pages/over-ptrn/over-ptrn';
import { Projectformat } from '../pages/projectformat/projectformat';
import { Werkwijze } from '../pages/werkwijze/werkwijze';
import { Aanmelden } from '../pages/aanmelden/aanmelden';
import { Presentaties } from '../pages/presentaties/presentaties';
import { VolgendeBijeenkomst } from '../pages/volgende-bijeenkomst/volgende-bijeenkomst';
import { Bijeenkomst } from '../pages/bijeenkomst/bijeenkomst';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ProjectComponent,
    Contact,
    Deelnemers,
    OverPTRN,
    Projectformat,
    Werkwijze,
    Aanmelden,
    Presentaties,
    VolgendeBijeenkomst,
    Bijeenkomst
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ProjectComponent,
    Contact,
    Deelnemers,
    OverPTRN,
    Projectformat,
    Werkwijze,
    Aanmelden,
    Presentaties,
    VolgendeBijeenkomst,
    Bijeenkomst
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts